import _, {curry, each, filter, find, isArray, omit, pick, property, reject, values} from 'lodash';
import $ from 'jquery';
import moment from 'moment';
import {ajaxRequest} from './sinclair.ajax';
import {messageHandler} from './sinclair.uiTools';
import tagSearchListTemplate from '../templates/stories/tagSearchList.hbs';
import {
    setUrlParameters as changeUrlParameters,
    getUrlParameter as fetchUrlParameter,
} from '@sinclair-digital/sbg-storyline-components/src/components/PackageSearch/url';
import {toString} from 'ramda';

export const getUrlParameter = (key, url = window.location.href) => {
    return fetchUrlParameter(key, url);
};

export const setUrlParameters = changeUrlParameters;

export function cloneObject(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export function createImmutableCopy(obj) {
    return Object.freeze(cloneObject(obj));
}

//:: (String -> a -> {a} | ()) -> Boolean
export const safePropEq = curry((k, v, o) => property(k)(o) === v);

// Check all prototypes of an object for constructor
//:: Constructor -> Object -> Boolean
export const descendsFrom = (constructor, obj) => constructor.prototype.isPrototypeOf(obj);

export function toLocalTimeFormat(utc) {
    return moment(utc).format('MMMM Do YYYY, h:mm a');
}

export function isValidLayout(obj) {
    if (!isArray(obj)) {
        return false;
    }

    return true;
}

export function responseParser(r) {
    let result = {
        success: false,
    };

    try {
        const r1 = typeof r === 'string' ? JSON.parse(r) : {};
        const r2 = typeof r1 === 'object' && typeof r1.response === 'string' ? JSON.parse(r1.response) : r1;

        result = r2.response && typeof r2.response === 'string' ? JSON.parse(r2.response) : r2;
    } catch (e) {
        result = {
            success: true,
        };
    }
    return result;
}

export function getComponentsByType(type, data) {
    let components = [];
    //TODO replace this with a reduce.
    each(data, function(v) {
        each(v, function(vv) {
            const c = type
                ? filter(vv, function(component) {
                    return component.type === type;
                })
                : vv;
            components = c === undefined ? components : components.concat(c);
        });
    });

    return components;
}

export function getComponentByNameSpace(namespace, data) {
    let component = {},
        c = null;

    each(data, function(v) {
        each(v, function(vv) {
            c = find(vv, function(subComponent) {
                return subComponent.namespace === namespace;
            });

            component = c === undefined ? component : c;
        });
    });

    return component;
}

export function getSettingsArray(properties) {
    const settings = {};

    $(properties).each(function() {
        settings[this] = '';
    });

    return settings;
}

export function getComponentSettings(component) {
    const settings = {};

    $.each(component.properties, function() {
        settings[this.name] = this.defaultValue;
    });

    return settings;
}

export function getComponentConfig(component, location) {
    return {
        settings: getComponentSettings(component),
        query: null,
        uid: Date.now(),
        lookup: component.namespace,
        name: component.name,
        version: component.version,
        area: location.area,
    };
}

/*
 *   Filters a list of DOM based on their data value
 *   This method searches each data attribute value on the DOM element and hides it if any of the filter terms are
 *   not present
 *   @param $targets - jQuery selected list of targets to be filtered with a data attribute on it
 *   @param terms - string of terms to filter by separated by spaces
 */
export function filterList($targets, terms, exclude, el) {
    const targetCount = $targets.length;
    let $target = null,
        isValid = true,
        i,
        j,
        allVals;

    const _isInString = function _isInString(val) {
        return val
            ? toString(val)
                .toLowerCase()
                .includes(terms[j])
            : false;
    };

    exclude = exclude || [];
    el = el || null;

    terms = terms
        .toLowerCase()
        .trim()
        .split(' ');

    for (i = 0; i < targetCount; i++) {
        $target = $($targets[i]);
        isValid = true;
        allVals = values(omit($target.data(), exclude)).filter(function(nonEmpty) {
            return nonEmpty;
        });

        // loop through each term to see if it is present in all values passed through the target data object
        // (excluding excludes)
        for (j = 0; j < terms.length; j++) {
            isValid = !!find(allVals, _isInString);
            // search term not found
            if (!isValid) {
                if (el) {
                    $target.closest(el).hide();
                } else {
                    $target.hide();
                }
                break;
                // search term found
            } else {
                if (el) {
                    $target.closest(el).show();
                } else {
                    $target.show();
                }
            }
        }
    }
}

export function capitalizeFirstLetter(word) {
    return typeof word === 'string' ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : '';
}

export function getFilterFieldUUID() {
    return 'relevance.tagRelevance.name';
}

export function getFilterFieldName() {
    return 'Property';
}

export function clearFileInput(el) {
    const $el = $(el);
    $el.wrap('<form>')
        .closest('form')
        .get(0)
        .reset();
    $el.unwrap();
}

export function getSiteTreeSearchNodes(children, searchTerm) {
    let temp = [],
        nodes = filter(children, function(child) {
            const term = searchTerm.toLowerCase();
            const name = child && child.name && typeof child.name === 'string' ? child.name.toLowerCase() : '';
            const path = child && child.pathUrl && typeof child.pathUrl === 'string' ? child.pathUrl.toLowerCase() : '';

            return !!(name.indexOf(term) > 0 || path.indexOf(term) > 0);
        });

    if (children && isArray(children)) {
        $(children).each(function() {
            if (this.children && isArray(this.children)) {
                temp = getSiteTreeSearchNodes(this.children, searchTerm, 0);
                nodes = temp && isArray(temp) ? nodes.concat(temp) : nodes;
            }
        });
    }

    return nodes && isArray(nodes) ? nodes : [];
}

export function getFilterQuery(li) {
    const querys = [];

    $(li).each(function() {
        querys.push({
            field: $(this).attr('data-field'),
            operation: $(this).attr('data-operator'),
            value: $(this).attr('data-name'),
        });
    });

    return querys;
}

// DEPRECATED
// TODO: Remove once ImageModelv1 is no longer used
export const Tagging = (function() {
    const init = function(context) {
        this.context = context;
    };

    const _openTagPanel = function() {
        const that = this.context;
        let tagItems = '';
        if (that.tags) {
            // Sort tags - Primary: Removable? Secondary: Alphabetical by Name
            that.tags = _(that.tags)
                .chain()
                .sortBy(function(tag) {
                    return tag.name.toString().toLowerCase();
                })
                .sortBy(function(tag) {
                    return tag.removable;
                })
                .value();
            for (let i = 0; i < that.tags.length; i++) {
                const tag = that.tags[i];
                tagItems += that._formatTag(tag);
            }
            $('#' + that.model.type + '-tag-list').html(tagItems);
        }

        $('#' + that.model.type + '-tag-panel').open();
    };
    const _updateTags = function() {
        const that = this.context;
        that.tags = [];

        $('#' + that.model.type + '-tag-list .tag').each(function() {
            const tag = {};
            tag.name = $(this).data('tag-name');
            tag.dimension = $(this).data('tag-dimension');
            tag.weight = $(this).data('tag-weight');
            tag.removable = $(this).data('tag-removable');
            //need to change to tag object when endpoint handles it
            that.tags.push(tag);
        });
        that._createTagMessage(that);
        that._closeTagPanel();

        return that;
    };
    const _closeTagPanel = function() {
        const that = this.context;
        that._createTagMessage(that);
        $('#' + that.model.type + '-tag-panel').removeClass('panel-open');
    };
    const _createTagMessage = function(that) {
        this.context = that;
        let tagMessage = '',
            sourceMessage = '',
            numTags = 0,
            numSources = 0;
        const tags = that.tags;
        const $tagLinkData = $('#' + that.model.type + '-tags-setting-link').data();
        const $ownershipLinkData = $('#' + that.model.type + '-ownership-setting-link').data();
        const sources = filter(tags, {dimension: 'Source'});

        if (tags) {
            numTags = tags.length;
        }

        if (numTags === 1) {
            tagMessage = 'Edit tags (' + numTags + ' tag)';
        } else if (numTags > 1) {
            tagMessage = 'Edit tags (' + numTags + ' tags)';
        } else {
            tagMessage = 'Add tags (0 tags)';
        }

        if (sources) {
            numSources = sources.length;
        }

        if (numSources === 1) {
            sourceMessage = 'Edit sources (' + numSources + ' tag)';
        } else if (numTags > 1) {
            sourceMessage = 'Edit sources (' + numSources + ' tags)';
        } else {
            sourceMessage = 'Add tags (0 tags)';
        }
        if ($ownershipLinkData) {
            $ownershipLinkData.setInfo(sourceMessage);
        }

        if ($tagLinkData) {
            $tagLinkData.setInfo(tagMessage);
        }

        return that;
    };
    const _shouldSearchTags = function() {
        const that = this.context;
        const val = $('#' + that.model.type + '-tag-input')
            .val()
            .toLowerCase()
            .trim();

        // If there is no search term
        if (val.length === 0) {
            if (that.lastTagSearch.ajaxInProgress && that.lastTagSearch.ajaxInProgress.state() === 'pending') {
                that.lastTagSearch.ajaxInProgress.abort();
            }
            return false;
        }

        // If current search term is the same as the last search term
        if (val === that.lastTagSearch.val) {
            return false;
        }

        // If current tag search is in progress, do not request another.
        if (that.lastTagSearch.ajaxInProgress && that.lastTagSearch.ajaxInProgress.state() === 'pending') {
            return false;
        }

        // If the search term is an extension of the last and the last returned less than 10 results.
        if (val.includes(that.lastTagSearch.val) && that.lastTagSearch.qty < that.tagSearchLimit) {
            return false;
        }

        return true;
    };
    const _searchForTags = function() {
        const that = this.context;
        const term = $('#' + that.model.type + '-tag-input')
            .val()
            .trim()
            .toLowerCase();
        const opts = {
            type: 'GET',
            timeout: 3000,
            url: '/api/rest/facade/tag/search',
            data: {
                term,
                limit: that.tagSearchLimit,
            },
            success(_data) {
                const data = Array.isArray(_data.data) ? _data.data : _data;
                $('#' + that.model.type + '-tags-dropdown').html(tagSearchListTemplate(data));
                that.lastTagSearch.val = term;
                that.lastTagSearch.qty = data.length;

                if (that._shouldSearchTags()) {
                    that._searchForTags();
                } else if (term.length === 0) {
                    that._clearTagSearch();
                } else {
                    that._filterTagList();
                }
            },
            failure(err) {
                console.log('tag search Failure', err);
                $('#' + that.model.type + '-tags-dropdown').html(tagSearchListTemplate([]));
            },
        };
        that._clearTagSearch();
        that.lastTagSearch.ajaxInProgress = ajaxRequest(opts);
    };
    const _clearTagSearch = function() {
        const that = this.context;

        that.lastTagSearch.val = null;
        $('#' + that.model.type + '-tags-dropdown').html('');
        $('#' + that.model.type + '-tag-categories').removeClass('sda-dropdown-open');
        $('#' + that.model.type + '-tags-dropdown').addClass('sda-dropdown-open');
    };
    const _filterTagList = function() {
        const that = this.context;
        const filterString = $('#' + that.model.type + '-tag-input').val();
        const exclude = ['weight', 'removable'];
        const targetParent = 'li';

        filterList($('.story-tag-result'), filterString, exclude, targetParent);
    };
    const _traverseTagDropdowns = function(direction) {
        const focusClass = 'focused-tagging-option';
        const $li = $('.sda-dropdown-open>li:visible');
        const $currentFocus = $('.' + focusClass);
        if (direction === 'up') {
            if ($currentFocus.length) {
                if ($currentFocus.prev(':visible')) {
                    $currentFocus
                        .removeClass(focusClass)
                        .prev(':visible')
                        .addClass(focusClass);
                } else {
                    $currentFocus.removeClass(focusClass);
                    $li.last().addClass(focusClass);
                }
            } else {
                $li.last().addClass(focusClass);
            }
        } else if (direction === 'down') {
            if ($currentFocus.length) {
                if ($currentFocus.next(':visible')) {
                    $currentFocus
                        .removeClass(focusClass)
                        .next(':visible')
                        .addClass(focusClass);
                } else {
                    $currentFocus.removeClass(focusClass);
                    $li.first().addClass(focusClass);
                }
            } else {
                $li.first().addClass(focusClass);
            }
        }
    };
    const _tagInputHandler = function(e) {
        const that = this.context;
        const val = $('#' + that.model.type + '-tag-input').val();
        const $currentDropdown = $(e.target)
            .parent()
            .find('.sda-dropdown-open');
        const focusClass = '.focused-tagging-option';

        if (val.length && that._shouldSearchTags()) {
            that._searchForTags();
        } else {
            that._filterTagList();
        }

        if (val.length === 0) {
            that._clearTagSearch();
        }

        switch (e.which) {
            case 13: // Enter = add new tag (if no results) or searches
                if ($('.story-tag-result:visible').length === 0) {
                    that._showTagCategories();
                } else {
                    if ($(focusClass).length) {
                        $(focusClass)
                            .find('a')
                            .trigger('click')
                            .removeClass(focusClass);
                    } else {
                        that._searchForTags();
                    }
                }
                break;

            case 27: // escape
                $(e.target).val('');
                that._clearTagSearch();
                break;

            case 38: // up arrow
                e.preventDefault();
                if ($currentDropdown.attr('id') === that.model.type + '-tags-dropdown') {
                    that._traverseTagDropdowns('up');
                }
                break;

            case 40: //down arrow
                e.preventDefault();
                if ($currentDropdown.attr('id') === that.model.type + '-tags-dropdown') {
                    that._traverseTagDropdowns('down');
                }
                break;
        }
    };
    const _showTagCategories = function() {
        const that = this.context;

        if ($('#' + that.model.type + '-tag-input').val()) {
            $('#' + that.model.type + '-tags-dropdown').removeClass('sda-dropdown-open');
            that._addTagCategories(that.userModel);
            $('#' + that.model.type + '-tag-categories').addClass('sda-dropdown-open');
            $('#' + that.model.type + '-tag-input').focus();
        } else {
            messageHandler('error', 'Please enter a tag name first');
        }
    };
    const _selectTagCategory = function(e) {
        const that = this.context;
        let val = $('#' + that.model.type + '-tag-input')
            .val()
            .trim()
            .replace(/\s{2,}/g, ' ');
        const $caller = $(e.target);
        const dimension = $caller.data('category');
        const weight = 1;
        const removable = true;

        if (val !== '') {
            if (val.length > 40) {
                val = val.substr(0, 40);
            }

            const tag = {
                name: val,
                dimension,
                weight,
                removable,
            };

            $('#' + that.model.type + '-tag-input')
                .val('')
                .focus();
            that._addTag(tag);
            that._hideDropdown();
            $('#' + that.model.type + '-tags-dropdown')
                .html('')
                .addClass('sda-dropdown-open');
        }
    };
    const _hideDropdown = function(event) {
        const e = event || {target: null};
        const $caller = $(e.target);
        const $callerSiblingDropdown = $caller.closest('.sda-input-group-btn').children('ul[class*=dropdown]');
        const $openDropdowns = $('.sda-dropdown-open');
        const $dropdowns = $('ul[class*=dropdown]');

        if (!$dropdowns.is($callerSiblingDropdown) && $dropdowns.has($callerSiblingDropdown).length === 0) {
            if ($openDropdowns.has($('#story-targets-dropdown')).length > 0) {
                $('#story-targets-dropdown')
                    .find('li.selected')
                    .removeClass('selected');
                $('#story-targets').val('');
            } else if ($openDropdowns.attr('id') && $openDropdowns.attr('id').includes('story-tag')) {
                $('#tag-input').val('');
                $('#story-tag-results').html('');
            }

            $('.panel-section.dim').removeClass('dim');

            $openDropdowns.removeClass('sda-dropdown-open');

            $('#story-targets').val('');
            $('#story-targets-dropdown')
                .find('li.selected')
                .removeClass('selected');
        }
    };
    const _selectTag = function(e) {
        const that = this.context;
        const tag = $(e.target)
            .closest('.story-tag-result')
            .data();
        that._addTag(tag);
        that._hideDropdown();
        $('#story-tags-dropdown').html('');
        that.lastTagSearch.val = null;
    };
    const _addTag = function(tag) {
        const that = this.context;

        if (
            filter(that.tags, function(tg) {
                return (
                    tg.name.toString().toLowerCase() === tag.name.toString().toLowerCase() &&
                    tg.dimension.toString().toLowerCase() === tag.dimension.toString().toLowerCase()
                );
            }).length === 0
        ) {
            that.tags.push(tag);
            $('#' + that.model.type + '-tag-list').prepend(that._formatTag(tag));
        }
    };
    const _addTags = function(tags) {
        const that = this.context;

        if ($.isArray(tags)) {
            each(tags, that._addTag);
        }

        that._createTagMessage(that);
    };
    const _removeTag = function(tag) {
        const that = this.context;
        that.tags = reject(that.tags, pick(tag, ['name', 'dimension']));
        that._createTagMessage(that);
    };
    const _removeTags = function(tags) {
        const that = this.context;
        if ($.isArray(tags)) {
            each(tags, this._removeTag);
        }

        return that;
    };
    const _removeTagHandler = function(e) {
        const $caller = $(e.target);

        $caller.parents('li').remove();
    };

    $.fn.autoGrowInput = function(o) {
        o = $.extend(
            {
                maxWidth: 1000,
                minWidth: 0,
                comfortZone: 70,
            },
            o,
        );

        this.filter('input:text').each(function() {
            const minWidth = o.minWidth || $(this).width();
            let val = '';
            const input = $(this);
            const testSubject = $('<tester/>').css({
                position: 'absolute',
                top: -9999,
                left: -9999,
                width: 'auto',
                fontSize: input.css('fontSize'),
                fontFamily: input.css('fontFamily'),
                fontWeight: input.css('fontWeight'),
                letterSpacing: input.css('letterSpacing'),
                whiteSpace: 'nowrap',
            });
            const check = function() {
                if (val === (val = input.val())) {
                    return;
                }

                // Enter new content into testSubject
                const escaped = val
                    .replace(/&/g, '&amp;')
                    .replace(/\s/g, '&nbsp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;');
                testSubject.html(escaped);

                // Calculate new width + whether to change
                const testerWidth = testSubject.width();
                const newWidth = testerWidth + o.comfortZone >= minWidth ? testerWidth + o.comfortZone : minWidth;
                const currentWidth = input.width();
                const isValidWidthChange =
                    (newWidth < currentWidth && newWidth >= minWidth) || (newWidth > minWidth && newWidth < o.maxWidth);

                // Animate width
                if (isValidWidthChange) {
                    input.width(newWidth);
                }
            };

            testSubject.insertAfter(input);

            $(this).bind('keyup keydown blur update', check);
        });
        return this;
    };

    return {
        init,
        _openTagPanel,
        _updateTags,
        _closeTagPanel,
        _createTagMessage,
        _shouldSearchTags,
        _searchForTags,
        _clearTagSearch,
        _filterTagList,
        _traverseTagDropdowns,
        _tagInputHandler,
        _showTagCategories,
        _selectTagCategory,
        _selectTag,
        _addTag,
        _addTags,
        _removeTag,
        _removeTags,
        _removeTagHandler,
        _hideDropdown,
    };
})();

$.fn.textWidth = function(text, font) {
    if (!$.fn.textWidth.fakeEl) {
        $.fn.textWidth.fakeEl = $('<span>')
            .hide()
            .appendTo(document.body);
    }
    $.fn.textWidth.fakeEl.text(text || this.val() || this.text()).css('font', font || this.css('font'));

    return $.fn.textWidth.fakeEl.width();
};

// Get array containing values of all matched elements
//:: jQuery Element String -> [String]
$.fn.vals = function() {
    return this.get().map(el => $(el).val());
};
